<template>
  <check-base-layout :pagetitle="pagetitle">
    <template>
      <slot></slot>
    </template>
    <template #checkFooter>
      <slot name="footer">
        <check-info-module :check-data="checkFrom.systemFlowRunAuditOrgVos"></check-info-module>
      </slot>
    </template>
  </check-base-layout>
</template>

<script>
import poMixins from '@/mixin/poMixins'
import checkApi from '@/api/workbench/check'
export default {
  name: 'customershiftCheck',
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '客户关系转移审批'
    }
  },
  data () {
    return {}
  }
}
</script>

<style scoped>

</style>
